import { Chain, EVMChain } from '../interfaces/common'
import { Wallet } from '../providers/WalletProvider'

interface ChainOwner {
  chain?: Chain
  evmChain?: EVMChain
}

export const getWalletAddress = (
  chainOwner: ChainOwner | undefined,
  wallet: Wallet,
  options?: { useIcpAccountId?: boolean }
) => {
  if (chainOwner?.evmChain) {
    return wallet.ethAddress
  } else if (chainOwner?.chain === Chain.ICP || chainOwner?.chain === Chain.ODIN) {
    return options?.useIcpAccountId ? wallet.accountId : wallet.principalId
  } else if (chainOwner?.chain === Chain.BTC) {
    return wallet.btcAddress
  } else if (chainOwner?.chain === Chain.SOL) {
    return wallet.solAddress
  } else if (chainOwner?.chain === Chain.DOGE) {
    return wallet.dogeAddress
  }
}
